import { useReactiveVar } from '@apollo/client';
import { useNavigation } from '@react-navigation/core';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Linking } from 'react-native';
import { featureCountryCode } from 'states/persistInStorage';
import { AccountNavProps } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import {
  CountryRegionDynamicInfo,
  parseFeatureFlagObject,
  showFeatureFlag,
} from 'utils/featureFlagUtils';
import { rateApp } from 'utils/rateAppUtils';
import { MenuItemWrapped, MenuSection } from './MenuComponents';

const SupportFeedbackMenu = () => {
  const {
    flags: { rate, country_region_dynamic_info },
  } = useContext(FeatureFlagsContext);
  const showRateApp = showFeatureFlag(rate);
  const countryRegionDynamicInfo =
    parseFeatureFlagObject<CountryRegionDynamicInfo>(
      country_region_dynamic_info,
      'country_region_dynamic_info'
    );
  const appCountryCode = useReactiveVar(featureCountryCode);
  const countryInfo = countryRegionDynamicInfo[appCountryCode || 'SE'];
  const { t } = useTranslation();
  const { navigate } = useNavigation<AccountNavProps>();

  const openReclamationURL = (url: string) => {
    Linking.openURL(url).catch((err) =>
      console.error('Failed to open URL:', err)
    );
  };

  return (
    <MenuSection headline={t('account.supportFeedback')}>
      <MenuItemWrapped
        menuLabel={t('account.reclamation')}
        iconName="Control-Fee"
        testID="reclamation-link"
        onPress={() => openReclamationURL(countryInfo.reclamationUrl)}
        arrowIcon="External-Link-Outlined"
      />
      <MenuItemWrapped
        menuLabel={t('account.contactUs.title')}
        iconName="Phone-Outlined"
        testID="contact-us-link"
        onPress={() => navigate('contactUs')}
      />
      {!isWeb && showRateApp && (
        <MenuItemWrapped
          menuLabel={t('account.rateApp')}
          iconName="Star-Outlined"
          testID="rate-app-link"
          onPress={rateApp}
        />
      )}
      <MenuItemWrapped
        menuLabel={t('account.tutorials.title')}
        iconName="Tutorial"
        testID="feedback-link"
        onPress={() => navigate('tutorials')}
        noBorder
      />
    </MenuSection>
  );
};

export default SupportFeedbackMenu;
